import { isAppActive, subscribeAppActivity } from '../utils/appActivity';

// A card is seen only while half of it is visible for a continuous 500 ms.
// One observer per list, no mark-all and no observation in a background tab.
export function observeNotifications(root, onSeen, { Observer = window.IntersectionObserver } = {}) {
  if (!root || !Observer) return () => {};
  const visible = new Set(), timers = new Map(), completed = new Set();
  const schedule = element => {
    if (!isAppActive() || completed.has(element) || timers.has(element)) return;
    timers.set(element, setTimeout(() => {
      timers.delete(element);
      if (!visible.has(element) || !isAppActive()) return;
      completed.add(element); onSeen(Number(element.dataset.notificationId));
    }, 500));
  };
  const observer = new Observer(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) { visible.add(entry.target); schedule(entry.target); }
      else { visible.delete(entry.target); clearTimeout(timers.get(entry.target)); timers.delete(entry.target); }
    });
  }, { root, threshold: [0, 0.5, 1] });
  root.querySelectorAll('[data-notification-id][data-seen="false"]').forEach(node => observer.observe(node));
  const unsubscribe = subscribeAppActivity(({ active }) => {
    timers.forEach(clearTimeout); timers.clear();
    if (active) visible.forEach(schedule);
  });
  return () => { observer.disconnect(); timers.forEach(clearTimeout); unsubscribe(); };
}
